function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _pt from 'prop-types';
import React, { useState } from 'react';
import { jsx, Global } from '@emotion/core';
import { Input, FormFeedback, Modal, ModalHeader, ModalBody, Row, Col, FormLabelGroup, ModalFooter, Button } from '@appfolio/react-gears';
import { observer } from 'mobx-react';
import { withStores } from "../contexts/StoresContext.js";
import useStores from "../hooks/useStores.js";
import i18n from 'i18next';
import "../i18n.js";
import useValidatedState from "../hooks/useValidatedState.js";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1ff7d3t",
  styles: "font-family:'Cookie',cursive;font-size:2.5rem;color:black !important;"
} : {
  name: "1ff7d3t",
  styles: "font-family:'Cookie',cursive;font-size:2.5rem;color:black !important;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNpZ25hdHVyZU1vZGFsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUErRGdCIiwiZmlsZSI6IlNpZ25hdHVyZU1vZGFsLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHsgY3NzLCBHbG9iYWwgfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCB7IG9ic2VydmVyIH0gZnJvbSAnbW9ieC1yZWFjdCc7XG5cbmltcG9ydCB7XG4gIE1vZGFsLFxuICBNb2RhbEhlYWRlcixcbiAgTW9kYWxCb2R5LFxuICBNb2RhbEZvb3RlcixcbiAgQnV0dG9uLFxuICBSb3csXG4gIENvbCxcbiAgRm9ybUxhYmVsR3JvdXAsXG4gIEZvcm1GZWVkYmFjayxcbiAgSW5wdXQsXG59IGZyb20gJ0BhcHBmb2xpby9yZWFjdC1nZWFycyc7XG5cbmltcG9ydCBpMThuIGZyb20gJy4uL2kxOG4nO1xuaW1wb3J0IHVzZVZhbGlkYXRlZFN0YXRlIGZyb20gJy4uL2hvb2tzL3VzZVZhbGlkYXRlZFN0YXRlJztcbmltcG9ydCB7IHdpdGhTdG9yZXMgfSBmcm9tICcuLi9jb250ZXh0cy9TdG9yZXNDb250ZXh0JztcbmltcG9ydCB1c2VTdG9yZXMgZnJvbSAnLi4vaG9va3MvdXNlU3RvcmVzJztcblxuaW50ZXJmYWNlIFNpZ25hdHVyZUZpZWxkSW5wdXRQcm9wcyB7XG4gIGZpZWxkOiBzdHJpbmc7XG4gIGVycm9yOiBzdHJpbmcgfCBudWxsO1xuICBhdXRvRm9jdXM/OiBib29sZWFuO1xuICBvbkNoYW5nZTogKGU6IFJlYWN0LkNoYW5nZUV2ZW50PEhUTUxJbnB1dEVsZW1lbnQ+KSA9PiB2b2lkO1xuICBvbktleURvd246IChlOiBSZWFjdC5LZXlib2FyZEV2ZW50PEhUTUxJbnB1dEVsZW1lbnQ+KSA9PiB2b2lkO1xuICBkaXNhYmxlZD86IGJvb2xlYW47XG4gIG1heExlbmd0aD86IG51bWJlcjtcbn1cblxuZXhwb3J0IGludGVyZmFjZSBTaWduYXR1cmVNb2RhbFByb3BzIHtcbiAgaXNPcGVuOiBib29sZWFuO1xuICBvbkNsb3NlOiAoKSA9PiB2b2lkO1xuICBvblN1Ym1pdDogKGZ1bGxOYW1lOiBzdHJpbmcsIGluaXRpYWxzOiBzdHJpbmcpID0+IHZvaWQ7XG4gIGxvY2FsZTogc3RyaW5nO1xuICBzaXplOiBzdHJpbmc7XG59XG5cbmludGVyZmFjZSBTaWduYXR1cmVNb2RhbEVycm9ycyB7XG4gIGZ1bGxOYW1lRXJyb3JNZXNzYWdlOiBzdHJpbmc7XG4gIGluaXRpYWxzRXJyb3JNZXNzYWdlOiBzdHJpbmc7XG59XG5cbmZ1bmN0aW9uIFNpZ25hdHVyZUZpZWxkSW5wdXQoe1xuICBmaWVsZCxcbiAgZXJyb3IsXG4gIGF1dG9Gb2N1cyA9IGZhbHNlLFxuICBvbkNoYW5nZSxcbiAgb25LZXlEb3duLFxuICBkaXNhYmxlZCxcbiAgbWF4TGVuZ3RoID0gSW5maW5pdHksXG59OiBTaWduYXR1cmVGaWVsZElucHV0UHJvcHMpOiBKU1guRWxlbWVudCB7XG4gIGNvbnN0IHZhbGlkID0gZXJyb3IgPT09ICcnO1xuXG4gIHJldHVybiAoXG4gICAgPFJlYWN0LkZyYWdtZW50PlxuICAgICAgPElucHV0XG4gICAgICAgIHR5cGU9XCJ0ZXh0XCJcbiAgICAgICAgYXV0b0ZvY3VzPXthdXRvRm9jdXN9XG4gICAgICAgIG1heExlbmd0aD17bWF4TGVuZ3RofVxuICAgICAgICBjc3M9e2Nzc2BcbiAgICAgICAgICBmb250LWZhbWlseTogJ0Nvb2tpZScsIGN1cnNpdmU7XG4gICAgICAgICAgZm9udC1zaXplOiAyLjVyZW07XG4gICAgICAgICAgY29sb3I6IGJsYWNrICFpbXBvcnRhbnQ7XG4gICAgICAgIGB9XG4gICAgICAgIHZhbHVlPXtmaWVsZH1cbiAgICAgICAgb25DaGFuZ2U9e29uQ2hhbmdlfVxuICAgICAgICBvbktleURvd249e29uS2V5RG93bn1cbiAgICAgICAgZGlzYWJsZWQ9e2Rpc2FibGVkfVxuICAgICAgICBpbnZhbGlkPXshdmFsaWR9XG4gICAgICAvPlxuICAgICAgeyF2YWxpZCAmJiA8Rm9ybUZlZWRiYWNrPntlcnJvcn08L0Zvcm1GZWVkYmFjaz59XG4gICAgPC9SZWFjdC5GcmFnbWVudD5cbiAgKTtcbn1cblxuY29uc3QgU2lnbmF0dXJlTW9kYWwgPSAoe1xuICBpc09wZW4sXG4gIG9uQ2xvc2UsXG4gIG9uU3VibWl0LFxuICBsb2NhbGUsXG4gIHNpemUsXG59OiBTaWduYXR1cmVNb2RhbFByb3BzKTogSlNYLkVsZW1lbnQgPT4ge1xuICBpMThuLmNoYW5nZUxhbmd1YWdlKGxvY2FsZSk7XG4gIGNvbnN0IHsgc2lnbmF0dXJlU3RvcmUgfSA9IHVzZVN0b3JlcygpO1xuICBjb25zdCB7IHZhbGlkYXRlRnVsbE5hbWUsIHZhbGlkYXRlSW5pdGlhbHMgfSA9IHNpZ25hdHVyZVN0b3JlO1xuXG4gIGNvbnN0IFtmdWxsTmFtZSwgZnVsbE5hbWVFcnJvciwgc2V0RnVsbE5hbWVdID0gdXNlVmFsaWRhdGVkU3RhdGU8c3RyaW5nPihcbiAgICAnJyxcbiAgICB2YWxpZGF0ZUZ1bGxOYW1lXG4gICk7XG4gIGNvbnN0IFtpbml0aWFscywgaW5pdGlhbHNFcnJvciwgc2V0SW5pdGlhbHNdID0gdXNlVmFsaWRhdGVkU3RhdGU8c3RyaW5nPihcbiAgICAnJyxcbiAgICB2YWxpZGF0ZUluaXRpYWxzXG4gICk7XG5cbiAgY29uc3QgW2Vycm9ycywgc2V0RXJyb3JzXSA9IHVzZVN0YXRlPFNpZ25hdHVyZU1vZGFsRXJyb3JzPih7XG4gICAgZnVsbE5hbWVFcnJvck1lc3NhZ2U6ICcnLFxuICAgIGluaXRpYWxzRXJyb3JNZXNzYWdlOiAnJyxcbiAgfSk7XG5cbiAgY29uc3QgaGFuZGxlU3VibWl0ID0gKCkgPT4ge1xuICAgIHNldEVycm9ycyh7XG4gICAgICBmdWxsTmFtZUVycm9yTWVzc2FnZTogZnVsbE5hbWVFcnJvcj8ubWVzc2FnZSB8fCAnJyxcbiAgICAgIGluaXRpYWxzRXJyb3JNZXNzYWdlOiBpbml0aWFsc0Vycm9yPy5tZXNzYWdlIHx8ICcnLFxuICAgIH0pO1xuICAgIGNvbnN0IGhhc0Vycm9ycyA9IGZ1bGxOYW1lRXJyb3IgfHwgaW5pdGlhbHNFcnJvcjtcblxuICAgIGlmIChoYXNFcnJvcnMpIHJldHVybjtcblxuICAgIHNpZ25hdHVyZVN0b3JlLnNldFNpZ25hdHVyZShmdWxsTmFtZSwgaW5pdGlhbHMpO1xuICAgIG9uU3VibWl0KGZ1bGxOYW1lLCBpbml0aWFscyk7XG4gICAgb25DbG9zZSgpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPE1vZGFsXG4gICAgICBpc09wZW49e2lzT3Blbn1cbiAgICAgIHRvZ2dsZT17b25DbG9zZX1cbiAgICAgIGF1dG9Gb2N1cz17ZmFsc2V9XG4gICAgICBiYWNrZHJvcFxuICAgICAgekluZGV4PVwiMTAwNTBcIlxuICAgICAgc2l6ZT17c2l6ZX1cbiAgICA+XG4gICAgICA8R2xvYmFsXG4gICAgICAgIHN0eWxlcz17e1xuICAgICAgICAgICcubW9kYWwnOiB7XG4gICAgICAgICAgICB6SW5kZXg6IDEwMDUwLFxuICAgICAgICAgIH0sXG4gICAgICAgIH19XG4gICAgICAvPlxuICAgICAgPE1vZGFsSGVhZGVyIHRvZ2dsZT17b25DbG9zZX0+XG4gICAgICAgIHtpMThuLnQoJ3NpZ25hYmxlcy5oZWFkaW5ncy5zZXR1cF9zaWduYXR1cmUnKX1cbiAgICAgIDwvTW9kYWxIZWFkZXI+XG5cbiAgICAgIDxNb2RhbEJvZHk+XG4gICAgICAgIHtpMThuLnQoJ3NpZ25hYmxlcy5tZXNzYWdlcy5jcmVhdGVfeW91cl9zaWduYXR1cmUnKX1cblxuICAgICAgICA8Um93IGNsYXNzTmFtZT1cIm10LTNcIj5cbiAgICAgICAgICA8Q29sIHhzPVwiOVwiPlxuICAgICAgICAgICAgPEZvcm1MYWJlbEdyb3VwXG4gICAgICAgICAgICAgIGxhYmVsPXtpMThuLnQoJ3NpZ25hYmxlcy5sYWJlbHMueW91cl9mdWxsX25hbWUnKX1cbiAgICAgICAgICAgICAgc3RhY2tlZFxuICAgICAgICAgICAgICByZXF1aXJlZFxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICA8U2lnbmF0dXJlRmllbGRJbnB1dFxuICAgICAgICAgICAgICAgIGZpZWxkPXtmdWxsTmFtZX1cbiAgICAgICAgICAgICAgICBlcnJvcj17ZXJyb3JzLmZ1bGxOYW1lRXJyb3JNZXNzYWdlfVxuICAgICAgICAgICAgICAgIG9uS2V5RG93bj17KGU6IFJlYWN0LktleWJvYXJkRXZlbnQ8SFRNTElucHV0RWxlbWVudD4pID0+IHtcbiAgICAgICAgICAgICAgICAgIGlmIChlLm5hdGl2ZUV2ZW50LmtleSA9PT0gJ0VudGVyJykgaGFuZGxlU3VibWl0KCk7XG4gICAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgICBhdXRvRm9jdXNcbiAgICAgICAgICAgICAgICBvbkNoYW5nZT17KGU6IFJlYWN0LkNoYW5nZUV2ZW50PEhUTUxJbnB1dEVsZW1lbnQ+KSA9PlxuICAgICAgICAgICAgICAgICAgc2V0RnVsbE5hbWUoZS50YXJnZXQudmFsdWUpXG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgPC9Gb3JtTGFiZWxHcm91cD5cbiAgICAgICAgICA8L0NvbD5cbiAgICAgICAgICA8Q29sIHhzPVwiM1wiPlxuICAgICAgICAgICAgPEZvcm1MYWJlbEdyb3VwXG4gICAgICAgICAgICAgIGxhYmVsPXtpMThuLnQoJ3NpZ25hYmxlcy5sYWJlbHMuaW5pdGlhbHMnKX1cbiAgICAgICAgICAgICAgc3RhY2tlZFxuICAgICAgICAgICAgICByZXF1aXJlZFxuICAgICAgICAgICAgPlxuICAgICAgICAgICAgICA8U2lnbmF0dXJlRmllbGRJbnB1dFxuICAgICAgICAgICAgICAgIGZpZWxkPXtpbml0aWFsc31cbiAgICAgICAgICAgICAgICBlcnJvcj17ZXJyb3JzLmluaXRpYWxzRXJyb3JNZXNzYWdlfVxuICAgICAgICAgICAgICAgIG9uS2V5RG93bj17KGU6IFJlYWN0LktleWJvYXJkRXZlbnQ8SFRNTElucHV0RWxlbWVudD4pID0+IHtcbiAgICAgICAgICAgICAgICAgIGlmIChlLm5hdGl2ZUV2ZW50LmtleSA9PT0gJ0VudGVyJykgaGFuZGxlU3VibWl0KCk7XG4gICAgICAgICAgICAgICAgfX1cbiAgICAgICAgICAgICAgICBvbkNoYW5nZT17KGU6IFJlYWN0LkNoYW5nZUV2ZW50PEhUTUxJbnB1dEVsZW1lbnQ+KSA9PlxuICAgICAgICAgICAgICAgICAgc2V0SW5pdGlhbHMoZS50YXJnZXQudmFsdWUudG9VcHBlckNhc2UoKSlcbiAgICAgICAgICAgICAgICB9XG4gICAgICAgICAgICAgICAgbWF4TGVuZ3RoPXs0fVxuICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgPC9Gb3JtTGFiZWxHcm91cD5cbiAgICAgICAgICA8L0NvbD5cbiAgICAgICAgPC9Sb3c+XG4gICAgICA8L01vZGFsQm9keT5cblxuICAgICAgPE1vZGFsRm9vdGVyPlxuICAgICAgICA8QnV0dG9uIGNvbG9yPVwicHJpbWFyeVwiIG9uQ2xpY2s9e2hhbmRsZVN1Ym1pdH0+XG4gICAgICAgICAge2kxOG4udCgnc2lnbmFibGVzLmFjdGlvbnMuY3JlYXRlX3NpZ25hdHVyZScpfVxuICAgICAgICA8L0J1dHRvbj5cbiAgICAgIDwvTW9kYWxGb290ZXI+XG4gICAgPC9Nb2RhbD5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IHdpdGhTdG9yZXMob2JzZXJ2ZXIoU2lnbmF0dXJlTW9kYWwpKTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function SignatureFieldInput(_ref2) {
  var field = _ref2.field,
      error = _ref2.error,
      _ref2$autoFocus = _ref2.autoFocus,
      autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus,
      onChange = _ref2.onChange,
      onKeyDown = _ref2.onKeyDown,
      disabled = _ref2.disabled,
      _ref2$maxLength = _ref2.maxLength,
      maxLength = _ref2$maxLength === void 0 ? Infinity : _ref2$maxLength;
  var valid = error === '';
  return jsx(React.Fragment, null, jsx(Input, {
    type: "text",
    autoFocus: autoFocus,
    maxLength: maxLength,
    css: _ref,
    value: field,
    onChange: onChange,
    onKeyDown: onKeyDown,
    disabled: disabled,
    invalid: !valid
  }), !valid && jsx(FormFeedback, null, error));
}

SignatureFieldInput.displayName = "SignatureFieldInput";
SignatureFieldInput.propTypes = {
  field: _pt.string.isRequired,
  error: _pt.oneOfType([_pt.string, _pt.oneOf([null])]),
  autoFocus: _pt.bool,
  onChange: _pt.func.isRequired,
  onKeyDown: _pt.func.isRequired,
  disabled: _pt.bool,
  maxLength: _pt.number,
  children: _pt.node
};

var SignatureModal = function SignatureModal(_ref3) {
  var isOpen = _ref3.isOpen,
      onClose = _ref3.onClose,
      onSubmit = _ref3.onSubmit,
      locale = _ref3.locale,
      size = _ref3.size;
  i18n.changeLanguage(locale);

  var _useStores = useStores(),
      signatureStore = _useStores.signatureStore;

  var validateFullName = signatureStore.validateFullName,
      validateInitials = signatureStore.validateInitials;

  var _useValidatedState = useValidatedState('', validateFullName),
      _useValidatedState2 = _slicedToArray(_useValidatedState, 3),
      fullName = _useValidatedState2[0],
      fullNameError = _useValidatedState2[1],
      setFullName = _useValidatedState2[2];

  var _useValidatedState3 = useValidatedState('', validateInitials),
      _useValidatedState4 = _slicedToArray(_useValidatedState3, 3),
      initials = _useValidatedState4[0],
      initialsError = _useValidatedState4[1],
      setInitials = _useValidatedState4[2];

  var _useState = useState({
    fullNameErrorMessage: '',
    initialsErrorMessage: ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var handleSubmit = function handleSubmit() {
    setErrors({
      fullNameErrorMessage: (fullNameError === null || fullNameError === void 0 ? void 0 : fullNameError.message) || '',
      initialsErrorMessage: (initialsError === null || initialsError === void 0 ? void 0 : initialsError.message) || ''
    });
    var hasErrors = fullNameError || initialsError;
    if (hasErrors) return;
    signatureStore.setSignature(fullName, initials);
    onSubmit(fullName, initials);
    onClose();
  };

  return jsx(Modal, {
    isOpen: isOpen,
    toggle: onClose,
    autoFocus: false,
    backdrop: true,
    zIndex: "10050",
    size: size
  }, jsx(Global, {
    styles: {
      '.modal': {
        zIndex: 10050
      }
    }
  }), jsx(ModalHeader, {
    toggle: onClose
  }, i18n.t('signables.headings.setup_signature')), jsx(ModalBody, null, i18n.t('signables.messages.create_your_signature'), jsx(Row, {
    className: "mt-3"
  }, jsx(Col, {
    xs: "9"
  }, jsx(FormLabelGroup, {
    label: i18n.t('signables.labels.your_full_name'),
    stacked: true,
    required: true
  }, jsx(SignatureFieldInput, {
    field: fullName,
    error: errors.fullNameErrorMessage,
    onKeyDown: function onKeyDown(e) {
      if (e.nativeEvent.key === 'Enter') handleSubmit();
    },
    autoFocus: true,
    onChange: function onChange(e) {
      return setFullName(e.target.value);
    }
  }))), jsx(Col, {
    xs: "3"
  }, jsx(FormLabelGroup, {
    label: i18n.t('signables.labels.initials'),
    stacked: true,
    required: true
  }, jsx(SignatureFieldInput, {
    field: initials,
    error: errors.initialsErrorMessage,
    onKeyDown: function onKeyDown(e) {
      if (e.nativeEvent.key === 'Enter') handleSubmit();
    },
    onChange: function onChange(e) {
      return setInitials(e.target.value.toUpperCase());
    },
    maxLength: 4
  }))))), jsx(ModalFooter, null, jsx(Button, {
    color: "primary",
    onClick: handleSubmit
  }, i18n.t('signables.actions.create_signature'))));
};

SignatureModal.displayName = "SignatureModal";
SignatureModal.propTypes = {
  isOpen: _pt.bool.isRequired,
  onClose: _pt.func.isRequired,
  onSubmit: _pt.func.isRequired,
  locale: _pt.string.isRequired,
  size: _pt.string.isRequired,
  children: _pt.node
};
var SignatureModal$1 = withStores(observer(SignatureModal));
export default SignatureModal$1;